import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Icon from '../components/AppIcon';
import Button from '../components/ui/Button';
import { useAuth } from '../contexts/AuthContext';
import { useDirection } from '../hooks/useDirection';

const Forbidden = () => {
  const { t } = useTranslation('common');
  const { isRTL } = useDirection();
  const { userProfile } = useAuth();
  const navigate = useNavigate();

  const handleGoBack = () => {
    const userRole = userProfile?.role;
    if (userRole === 'tenant') {
      navigate('/tenant-dashboard');
    } else if (userRole === 'admin') {
      navigate('/admin-dashboard');
    } else {
      navigate('/tenant-login');
    }
  };

  return (
    <div className={`min-h-screen bg-background flex items-center justify-center ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="max-w-md w-full mx-4">
        <div className="card-base text-center">
          {/* 403 Icon */}
          <div className="w-24 h-24 mx-auto mb-6 bg-error/10 rounded-full flex items-center justify-center">
            <Icon 
              name="ShieldX" 
              size={48} 
              className="text-error"
            />
          </div>

          {/* Error Code */}
          <div className="text-6xl font-bold text-error mb-4">403</div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-card-foreground mb-4">
            {t('errors.accessDenied')}
          </h1>

          {/* Description */}
          <p className="text-muted-foreground mb-8">
            {t('errors.accessDeniedDescription')}
          </p>

          {/* User Role Info */}
          {userProfile?.role && (
            <div className="bg-muted/50 rounded-lg p-4 mb-6">
              <p className="text-sm text-muted-foreground mb-2">
                {t('errors.currentRole')}
              </p>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-primary/10 text-primary">
                <Icon 
                  name={userProfile.role === 'admin' ? 'Shield' : 'User'} 
                  size={16} 
                  className={`${isRTL ? 'ml-2' : 'mr-2'}`}
                />
                {t(`roles.${userProfile.role}`)}
              </span>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={handleGoBack}
              variant="default"
              className="flex-1"
              iconName="Home"
              iconPosition={isRTL ? "right" : "left"}
            >
              {t('actions.goToDashboard')}
            </Button>
            
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              className="flex-1"
              iconName="ArrowLeft"
              iconPosition={isRTL ? "right" : "left"}
            >
              {t('actions.goBack')}
            </Button>
          </div>

          {/* Help Text */}
          <div className="mt-8 pt-6 border-t border-border">
            <p className="text-xs text-muted-foreground">
              {t('errors.contactSupport')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
